import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Autocomplete, Box, IconButton, InputAdornment, Tooltip } from '@mui/material';
import Grid from "@mui/material/Grid2"
import { send_authorized_request } from '../../Constants/cognito'
import { LoadingBackdropIndeterminate } from '../LoadingBackdrop';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SpeedIcon from '@mui/icons-material/Speed';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { AXIOS_API_INSTANCE } from '../../Constants';
import axios from 'axios';
import dayjs from "dayjs"
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { useSnackbar } from 'notistack';
import RentalNoteAccordion from './RentalNoteAccordion';
import OdometerReadingsAccordion from './OdometerReadingsAccordion';
import ContractHistoryAccordion from './ContractHistoryAccordion';
import { getDocumentation } from '../../Utils';

export default function RentalItem({ id, creatingNewRentalItem, newRentalItem, newlyCreatedCallback, editMode, backFunction }) {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = React.useState(false)
    const [isSaving, setIsSaving] = React.useState(false)
    const [rentalItem, setRentalItem] = React.useState({})
    const [locationSearch, setLocationSearch] = React.useState("")
    const [locationsIsLoading, setLocationsIsLoading] = React.useState(false)
    const [filteredLocations, setFilteredLocations] = React.useState({ rows: [], total_count: 0 })
    const [rentalTypeSearch, setRentalTypeSearch] = React.useState("")
    const [rentalTypeIsLoading, setRentalTypeIsLoading] = React.useState(false)
    const [filteredRentalType, setFilteredRentalType] = React.useState({ rows: [], total_count: 0 })
    const [isEditMode, setIsEditMode] = React.useState(editMode || false)

    const handleChange = (prop) => (event, sometimes_new_value) => {
        console.log(rentalItem)
        if (["rental_category_id", "rental_rate_group_id"].includes(prop)) {
            setRentalItem({
                ...rentalItem,
                [prop]: sometimes_new_value.id,
            })
        } else if (["purchase_date"].includes(prop)) {
            setRentalItem({
                ...rentalItem,
                [prop]: dayjs.utc(event),
            })
        } else {
            setRentalItem({
                ...rentalItem,
                [prop]: event.target.value,
            })
        }
    }

    const closeFunction = (exit) => {
        if (exit) {
            backFunction()
        } else if (isEditMode && !creatingNewRentalItem) {
            setIsEditMode(false)
        } else {
            backFunction()
        }
    }

    const uploadNewImage = (event) => {
        if (!event.target.files) {
            return;
        }
        const file = event.target.files[0];
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`rentalitems/${rentalItem.id}/image`, { image_name: file.name },).then((response) => {
                console.log(response)
                var bodyFormData = new FormData();
                for (const key in response.data.data.fields) {
                    bodyFormData.append(key, response.data.data.fields[key])
                }
                bodyFormData.append('file', file)
                axios.post(response.data.data.url, bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
                    console.log(response)
                    enqueueSnackbar('Successfully uploaded image', { variant: 'success' })
                    setRentalItem({
                        ...rentalItem,
                        image_path: file.name,
                    })
                })
            })
        )
    }

    const uploadNewDocumentation = (event) => {
        if (!event.target.files) {
            return;
        }
        const file = event.target.files[0];
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`rentalitems/${rentalItem.id}/documentation`, { documentation_name: file.name },).then((response) => {
                console.log(response)
                var bodyFormData = new FormData();
                for (const key in response.data.data.fields) {
                    bodyFormData.append(key, response.data.data.fields[key])
                }
                bodyFormData.append('file', file)
                axios.post(response.data.data.url, bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
                    console.log(response)
                    enqueueSnackbar('Successfully uploaded documentation', { variant: 'success' })
                    setRentalItem({
                        ...rentalItem,
                        documentation_path: file.name,
                    })
                })
            })
        )
    }

    const save = () => {
        console.log(rentalItem)
        var sending_rentalItem = structuredClone({ ...rentalItem, location: null })
        sending_rentalItem.purchase_date = rentalItem.purchase_date.toDate()
        delete sending_rentalItem.location
        delete sending_rentalItem.date_created
        delete sending_rentalItem.date_updated
        delete sending_rentalItem.currently_checked_out
        delete sending_rentalItem.rental_contract_items
        delete sending_rentalItem.rental_type
        delete sending_rentalItem.rental_notes
        setIsSaving(true)
        if (creatingNewRentalItem) {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.put(
                    `rentalitems`,
                    sending_rentalItem
                ).then((response) => {
                    enqueueSnackbar('Successfully created rental item', { variant: 'success' })
                    setIsSaving(false)
                    newlyCreatedCallback(response.data.data)
                })
            )
        } else {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(
                    `rentalitems/${sending_rentalItem.id}`,
                    sending_rentalItem
                ).then(() => {
                    enqueueSnackbar('Successfully updated rental item', { variant: 'success' })
                    setIsSaving(false)
                    getData()
                    setIsEditMode(false)
                })
            )
        }
    }
    const delete_rental_item = () => {
        console.log('delete rentalitem')
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.delete(`rentalitems/${rentalItem.id}`).then(
                axios.spread(() => {
                    enqueueSnackbar('Successfully deleted rental item', { variant: 'success' })
                    closeFunction(true)
                })
            )
        )
    }

    const getData = () => {
        console.log(id)
        console.log(creatingNewRentalItem)
        setIsLoading(true)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.get(`rentalitems/${id}`, {
                params: {
                    check_deletable: true
                },
            }).then((rentalItemData) => {
                console.log(rentalItemData)
                setRentalItem({ ...rentalItemData.data.data, purchase_date: dayjs(rentalItemData.data.data.purchase_date) })
                setIsLoading(false)
            }))
    }

    const getLocations = () => {
        setLocationsIsLoading(true)
        let my_filters = { "or": [] }
        my_filters["or"].push({ 'name.ilike': locationSearch || "" })
        my_filters["or"].push({ 'address_1.ilike': locationSearch || "" })
        my_filters["or"].push({ 'address_2.ilike': locationSearch || "" })
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("locations", {
                        params: {
                            page_num: 0,
                            page_size: 25,
                            filters: JSON.stringify(my_filters),
                        },
                    }),
                ])
                .then(
                    axios.spread((locations) => {
                        console.log(locations)
                        setFilteredLocations({
                            rows: locations.data.data,
                            total_count: locations.data.total_count,
                        })
                        setLocationsIsLoading(false)
                    })
                )
        )
    }

    const getRentalType = () => {
        setRentalTypeIsLoading(true)
        let my_filters = { "or": [] }
        my_filters["or"].push({ 'name.ilike': rentalTypeSearch || "" })
        my_filters["or"].push({ 'description.ilike': rentalTypeSearch || "" })
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentaltype", {
                        params: {
                            page_num: 0,
                            page_size: 25,
                            filters: JSON.stringify(my_filters),
                        },
                    }),
                ])
                .then(
                    axios.spread((rentalTypes) => {
                        console.log(rentalTypes)
                        setFilteredRentalType({
                            rows: rentalTypes.data.data,
                            total_count: rentalTypes.data.total_count,
                        })
                        setRentalTypeIsLoading(false)
                    })
                )
        )
    }

    React.useEffect(() => {
        getLocations()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationSearch])

    React.useEffect(() => {
        getRentalType()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rentalTypeSearch])

    React.useEffect(() => {
        if (creatingNewRentalItem) {
            setRentalItem(newRentalItem)
        } else {
            getData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    return (
        (<React.Fragment>
            <LoadingBackdropIndeterminate
                open={isLoading}
                text={"Loading Rental Item"}
            />
            <LoadingBackdropIndeterminate
                open={isSaving}
                text={"Saving Rental Item"}
            />
            {rentalItem.id !== undefined &&
                <Box sx={{ pl: 1, pr: 1 }}>
                    <Grid container space={1} alignItems="center" justifyContent={"flex-end"}>
                        <Grid size="grow">
                            <h2>{creatingNewRentalItem ? "CREATING NEW RENTAL ITEM" : (isEditMode ? "EDITING " : "") + rentalItem.unique_name}</h2>
                        </Grid>
                        {!isEditMode && !creatingNewRentalItem &&
                            <Grid size="auto">
                                <Button onClick={() => setIsEditMode(true)} sx={{ mr: 1 }}>
                                    <ModeEditIcon /> <Box sx={{ pl: 1 }}><span>Edit</span></Box>
                                </Button>
                            </Grid>
                        }
                        <Grid size="auto">
                            <IconButton onClick={() => closeFunction()}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container spacing={6}>
                        <Grid size={3}>
                            <Grid container direction={'column'} spacing={2}>
                                <Grid size="grow">
                                    <Box
                                        key={`${rentalItem.id}/${rentalItem.image_path}`}
                                        component={'img'}
                                        src={`/customerimages/client/${rentalItem.client_id}/rentalitems/${rentalItem.id}/${rentalItem.image_path}`}
                                        sx={{ maxHeight: '250px', maxWidth: '250px' }}
                                    />
                                </Grid>
                                <Grid size="grow">
                                    {(isEditMode || creatingNewRentalItem) &&
                                        <Button
                                            component="label"
                                            variant="outlined"
                                            startIcon={<UploadFileIcon />}
                                            sx={{ marginRight: "1rem" }}
                                            disabled={creatingNewRentalItem}
                                        >
                                            Upload Image
                                            <input type="file" accept="image/*" hidden onChange={uploadNewImage} />
                                        </Button>
                                    }
                                </Grid>
                                <Grid size="grow">
                                    {rentalItem?.documentation_path !== undefined && rentalItem?.documentation_path !== null && rentalItem?.documentation_path !== "" &&
                                        <Box>
                                            <Button onClick={() => getDocumentation(rentalItem, 'rentalitems')}><PictureAsPdfIcon />Documentation</Button>
                                        </Box>
                                    }
                                </Grid>
                                <Grid size="grow">
                                    {(isEditMode || creatingNewRentalItem) &&
                                        <Button
                                            component="label"
                                            variant="outlined"
                                            startIcon={<UploadFileIcon />}
                                            sx={{ marginRight: "1rem" }}
                                            disabled={creatingNewRentalItem}
                                        >
                                            Upload Documentation
                                            <input type="file" accept="" hidden onChange={uploadNewDocumentation} />
                                        </Button>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size="grow">
                            <Grid container spacing={6}>
                                <Grid size="grow">
                                    {(isEditMode || creatingNewRentalItem) &&
                                        <Grid container direction={'column'} spacing={2}>
                                            <Grid size="grow">
                                                <TextField
                                                    autoFocus
                                                    margin="dense"
                                                    id="unique_name"
                                                    label="Unique Name"
                                                    type="text"
                                                    fullWidth
                                                    variant="standard"
                                                    value={rentalItem.unique_name || ""}
                                                    onChange={handleChange("unique_name")}
                                                    slotProps={{
                                                        htmlInput: { maxLength: 255 }
                                                    }}
                                                />
                                            </Grid>
                                            {rentalItem?.rental_type.bulk_type &&
                                                <Grid size="grow">
                                                    <TextField
                                                        autoFocus
                                                        margin="dense"
                                                        id="total_quantity"
                                                        label="Total Quantity"
                                                        type="number"
                                                        fullWidth
                                                        variant="standard"
                                                        value={rentalItem.total_quantity || ""}
                                                        onChange={handleChange("total_quantity")}
                                                        slotProps={{
                                                            htmlInput: { min: 0 }
                                                        }}
                                                    />
                                                </Grid>
                                            }
                                            <Grid size="grow">
                                                <TextField
                                                    autoFocus
                                                    margin="dense"
                                                    id="sku"
                                                    label="SKU"
                                                    type="text"
                                                    fullWidth
                                                    variant="standard"
                                                    value={rentalItem.sku || ""}
                                                    onChange={handleChange("sku")}
                                                    slotProps={{
                                                        htmlInput: { maxLength: 255 }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size="grow">
                                                <TextField
                                                    autoFocus
                                                    margin="dense"
                                                    id="serial"
                                                    label="Serial"
                                                    type="text"
                                                    fullWidth
                                                    variant="standard"
                                                    value={rentalItem.serial || ""}
                                                    onChange={handleChange("serial")}
                                                    slotProps={{
                                                        htmlInput: { maxLength: 255 }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size="grow">
                                                <TextField
                                                    autoFocus
                                                    margin="dense"
                                                    id="model_unit_id"
                                                    label="Model Unit ID"
                                                    type="text"
                                                    fullWidth
                                                    variant="standard"
                                                    value={rentalItem.model_unit_id || ""}
                                                    onChange={handleChange("model_unit_id")}
                                                    slotProps={{
                                                        htmlInput: { maxLength: 255 }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size="grow">
                                                <Autocomplete
                                                    filterOptions={(x) => x}
                                                    getOptionLabel={(option) => `${option.name || ""} ${option.address_1 || ""} ${option.address_2 || ""}`}
                                                    options={filteredLocations.rows}
                                                    autoComplete
                                                    includeInputInList
                                                    filterSelectedOptions
                                                    value={rentalItem.location}
                                                    noOptionsText="No Locations"
                                                    loading={locationsIsLoading}
                                                    onChange={(event, newValue) => {
                                                        setRentalItem({ ...rentalItem, location: newValue, location_id: newValue.id })
                                                    }}
                                                    onInputChange={(event, newInputValue) => {
                                                        if (newInputValue.length > 0 && newInputValue.trim().length === 0) {
                                                            return
                                                        }
                                                        setLocationSearch(newInputValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Select a location" fullWidth />
                                                    )}
                                                    renderOption={(props, option, { inputValue }) => {
                                                        const matches = match(props.key, inputValue, { insideWords: true, findAllOccurrences: true });
                                                        const parts = parse(props.key, matches);
                                                        props.key = props.id

                                                        return (
                                                            <li {...props}>
                                                                <div>
                                                                    {parts.map((part, index) => (
                                                                        <span
                                                                            key={index}
                                                                            style={{
                                                                                fontWeight: part.highlight ? 700 : 400,
                                                                            }}
                                                                        >
                                                                            {part.text}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </li>
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size="grow">
                                                <Autocomplete
                                                    filterOptions={(x) => x}
                                                    getOptionLabel={(option) => `${option.name || ""} (${option.rental_category?.name || ""})`}
                                                    options={filteredRentalType.rows}
                                                    autoComplete
                                                    includeInputInList
                                                    filterSelectedOptions
                                                    value={rentalItem.rental_type}
                                                    noOptionsText="No Rental Types"
                                                    loading={rentalTypeIsLoading}
                                                    onChange={(event, newValue) => {
                                                        setRentalItem({ ...rentalItem, rental_type: newValue, rental_type_id: newValue.id })
                                                    }}
                                                    onInputChange={(event, newInputValue) => {
                                                        if (newInputValue.length > 0 && newInputValue.trim().length === 0) {
                                                            return
                                                        }
                                                        setRentalTypeSearch(newInputValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Select a Rental Type" fullWidth />
                                                    )}
                                                    renderOption={(props, option, { inputValue }) => {
                                                        const matches = match(props.key, inputValue, { insideWords: true, findAllOccurrences: true });
                                                        const parts = parse(props.key, matches);
                                                        props.key = props.id

                                                        return (
                                                            <li {...props}>
                                                                <div>
                                                                    {parts.map((part, index) => (
                                                                        <span
                                                                            key={index}
                                                                            style={{
                                                                                fontWeight: part.highlight ? 700 : 400,
                                                                            }}
                                                                        >
                                                                            {part.text}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </li>
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    }
                                    {(!isEditMode && !creatingNewRentalItem) &&
                                        <Grid container direction={"column"}>
                                            <Grid size="grow">
                                                <span>Unique Name: {rentalItem.unique_name}</span>
                                            </Grid>
                                            {rentalItem.bulk_type &&
                                                <Grid size="grow">
                                                    <span>Total Quantity: {rentalItem.total_quantity}</span>
                                                </Grid>
                                            }
                                            <Grid size="grow">
                                                <span>SKU: {rentalItem.sku}</span>
                                            </Grid>
                                            <Grid size="grow">
                                                <span>Serial: {rentalItem.serial}</span>
                                            </Grid>
                                            <Grid size="grow">
                                                <span>Model Unit ID: {rentalItem.model_unit_id}</span>
                                            </Grid>
                                            <Grid size="grow">
                                                <span>Location: {rentalItem.location.name}</span>
                                            </Grid>
                                            <Grid size="grow">
                                                <span>Type: {rentalItem.rental_type?.name}</span>
                                            </Grid>
                                            <Grid size="grow">
                                                <span>Category: {rentalItem.rental_type?.rental_category?.name}</span>
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid size="grow">
                                    {(isEditMode || creatingNewRentalItem) &&
                                        <Grid container direction={"column"} spacing={2}>
                                            <Grid size="grow">
                                                <span><b>Purchase:</b></span>
                                            </Grid>
                                            <Grid size="grow">
                                                <TextField
                                                    autoFocus
                                                    margin="dense"
                                                    id="purchase_price"
                                                    label="Purchase Price"
                                                    type="number"
                                                    fullWidth
                                                    variant="standard"
                                                    value={rentalItem.purchase_price || 0}
                                                    onChange={handleChange("purchase_price")}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <AttachMoneyIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size="grow">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Box>
                                                        <DesktopDatePicker
                                                            label="Purchase Date"
                                                            format="YYYY-MM-DD"
                                                            value={dayjs(rentalItem.purchase_date)}
                                                            onChange={handleChange("purchase_date")}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </Box>
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid size="grow">
                                                {rentalItem.rental_type && rentalItem.rental_type.has_odometer && <TextField
                                                    autoFocus
                                                    margin="dense"
                                                    id="starting_odometer_value"
                                                    label="Starting Odometer Value"
                                                    type="number"
                                                    fullWidth
                                                    variant="standard"
                                                    value={rentalItem.starting_odometer_value || 0}
                                                    onChange={handleChange("starting_odometer_value")}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <SpeedIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }
                                                    }}
                                                />}
                                            </Grid>
                                        </Grid>
                                    }
                                    {(!isEditMode && !creatingNewRentalItem) &&
                                        <Grid container direction={"column"}>
                                            <Grid size="grow">
                                                <span><b>Purchase:</b></span>
                                            </Grid>
                                            <Grid size="grow">
                                                <span>Price: ${rentalItem.purchase_price}</span>
                                            </Grid>
                                            <Grid size="grow">
                                                <span>Date: {dayjs(rentalItem.purchase_date).local().format('ddd, D MMM YYYY')}</span>
                                            </Grid>
                                            {rentalItem.rental_type && rentalItem.rental_type.has_odometer &&
                                                <Grid size="grow">
                                                    <span>Starting Odometer: {rentalItem.starting_odometer_value || 0} mi</span>
                                                </Grid>
                                            }
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>

                            {!isEditMode && !creatingNewRentalItem &&
                                <Box sx={{ pt: 2 }}>
                                    <RentalNoteAccordion
                                        refresh_function={getData}
                                        rental_item_id={rentalItem.id}
                                        rental_contract_item_id={undefined}
                                        disabled={creatingNewRentalItem}
                                    />
                                    <ContractHistoryAccordion
                                        rental_item_id={rentalItem.id}
                                        disabled={creatingNewRentalItem}
                                    />
                                    {rentalItem.rental_type && rentalItem.rental_type.has_odometer &&
                                        <OdometerReadingsAccordion
                                            refresh_function={getData}
                                            rental_item_id={rentalItem.id}
                                            rental_contract_item_id={undefined}
                                            disabled={creatingNewRentalItem}
                                        />
                                    }

                                </Box>
                            }
                        </Grid>
                    </Grid>

                    <Grid container spacing={10} sx={{ pt: 2 }} justifyContent={'flex-end'}>
                        <Grid size="grow"></Grid>
                        {(isEditMode && !creatingNewRentalItem) &&
                            <Grid justifyContent={'flex-end'} size='auto'>
                                <Tooltip title={rentalItem.deletable_reason}>
                                    <span> {/* span required for tooltip events */}
                                        <Button disabled={!rentalItem.deletable} variant='outlined' color='error' onClick={delete_rental_item} sx={{ mr: 1 }}>
                                            <DeleteIcon /> <Box sx={{ pl: 1 }}><span>Delete</span></Box>
                                        </Button>
                                    </span>
                                </Tooltip>
                            </Grid>
                        }
                        {(isEditMode || creatingNewRentalItem) &&
                            <Grid justifyContent={'flex-end'} size='auto'>
                                <Button variant='contained' onClick={() => save()} sx={{ mr: 1 }}>
                                    <SaveIcon /> <Box sx={{ pl: 1 }}><span>Save</span></Box>
                                </Button>
                            </Grid>
                        }
                    </Grid>
                </Box>
            }
        </React.Fragment >)
    );
}